<template>
  <footer class="main-footer">
    <div class="container">
      <section class="logo">
      © 2022 <b>GeoSolar Technologies, Inc.</b> All rights reserved.
      </section>
    </div>
  </footer>
</template>

<style lang="scss" scoped>
  @import '@/styles/components/footer.scss';
</style>

<script>
export default {
  name: 'Footer',
  data() {
    return {
    };
  },
};
</script>

